import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { RaceDrillDownContent } from './RaceDrillDown/RaceDrillDownContent';

interface Props {
  meetingId: string;
  trackName: string;
  meetingDate?: string;
  onClose: () => void;
}

/**
 * Right-side slide-over holding the meeting drill-down, so opening a meeting's
 * races no longer costs a full page load (the workflow brief's "one less click").
 * The full-page route at /meetings/:id/races still exists for deep links.
 */
export function MeetingRacesDrawer({ meetingId, trackName, meetingDate, onClose }: Props) {
  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed right-0 top-0 z-50 flex h-full w-full max-w-4xl flex-col border-l border-border bg-background shadow-xl">
          <div className="flex items-start justify-between gap-4 border-b border-border p-5">
            <div className="min-w-0">
              <Dialog.Title className="text-lg font-semibold">{trackName} — races</Dialog.Title>
              {meetingDate && <Dialog.Description className="text-sm text-muted-foreground">{meetingDate}</Dialog.Description>}
            </div>
            <Dialog.Close className="rounded-md p-1.5 text-muted-foreground hover:bg-accent hover:text-foreground" aria-label="Close">
              <X className="h-5 w-5" />
            </Dialog.Close>
          </div>
          <div className="flex-1 overflow-y-auto p-5">
            <RaceDrillDownContent meetingId={meetingId} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
